/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { NLAAM, NLAAMInterface } from "../NLAAM";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "stableCoin_",
        type: "address",
      },
      {
        internalType: "address",
        name: "pearl_",
        type: "address",
      },
      {
        internalType: "address",
        name: "blackPearl_",
        type: "address",
      },
      {
        internalType: "address",
        name: "roles_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "NLAMM_InvalidMetadataLimits",
    type: "error",
  },
  {
    inputs: [],
    name: "NLAMM_TokenAlreadyConfigured",
    type: "error",
  },
  {
    inputs: [],
    name: "NLAMM_TokenNotConfigured",
    type: "error",
  },
  {
    inputs: [],
    name: "NLAMM_ValueGreaterThanExpected",
    type: "error",
  },
  {
    inputs: [],
    name: "Ownable_NewOwnerCannotBeAddressZero",
    type: "error",
  },
  {
    inputs: [],
    name: "Ownable_SenderIsNotOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferHelper_GetBalanceError",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferHelper_TransferError",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferHelper_TransferFromError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "basePrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "targetPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currentPrice",
        type: "uint256",
      },
    ],
    name: "Buy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
      {
        internalType: "uint16[]",
        name: "metadataLimits",
        type: "uint16[]",
      },
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "incrementValuePerPurchase",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "decreaseSharePerOneHour",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentToTargetSharePerOneHour",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "basePriceShareIncrementPerOneHour",
        type: "uint256",
      },
    ],
    name: "addToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "blackPearl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
    ],
    name: "getPrices",
    outputs: [
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "targetPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentPrice",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
    ],
    name: "getToken",
    outputs: [
      {
        components: [
          {
            internalType: "uint16[]",
            name: "metadataLimits",
            type: "uint16[]",
          },
          {
            internalType: "uint80",
            name: "basePrice",
            type: "uint80",
          },
          {
            internalType: "uint80",
            name: "targetPrice",
            type: "uint80",
          },
          {
            internalType: "uint80",
            name: "currentPrice",
            type: "uint80",
          },
          {
            internalType: "uint256",
            name: "incrementValuePerPurchase",
            type: "uint256",
          },
          {
            internalType: "uint72",
            name: "decreaseSharePerOneHour",
            type: "uint72",
          },
          {
            internalType: "uint72",
            name: "currentToTargetSharePerOneHour",
            type: "uint72",
          },
          {
            internalType: "uint72",
            name: "basePriceShareIncrementPerOneHour",
            type: "uint72",
          },
          {
            internalType: "uint40",
            name: "latestBuyTimestamp",
            type: "uint40",
          },
        ],
        internalType: "struct INLAMM.Token",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pearl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "roles",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stableCoin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
      {
        internalType: "uint16[]",
        name: "metadataLimits",
        type: "uint16[]",
      },
    ],
    name: "updateMetadataLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenIndex",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "incrementValuePerPurchase",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "decreaseSharePerOneHour",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentToTargetSharePerOneHour",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "basePriceShareIncrementPerOneHour",
        type: "uint256",
      },
    ],
    name: "updateToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "withdrawERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class NLAAM__factory {
  static readonly abi = _abi;
  static createInterface(): NLAAMInterface {
    return new Interface(_abi) as NLAAMInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): NLAAM {
    return new Contract(address, _abi, runner) as unknown as NLAAM;
  }
}
